import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand col-md-3 col-lg-2 me-0 px-3",
  href: "#"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://admindev.quickup.uk/logo.png",
    alt: "logo",
    style: {"width":"160px!important"}
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-bars" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "container-fluid" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "side-bar-menu" }
const _hoisted_8 = { class: "wrapper d-flex flex-column flex-row-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_menu_bar = _resolveComponent("app-menu-bar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: "btn-toggle",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.sidebarfunction && $setup.sidebarfunction(...args)))
      }, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_app_menu_bar, {
            isshowsidebar: $setup.toogle.showMenu
          }, null, 8, ["isshowsidebar"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("main", {
            class: _normalizeClass(["content", $setup.toogle.sidbarclass])
          }, [
            _createVNode(_component_router_view)
          ], 2)
        ])
      ])
    ])
  ], 64))
}